import { getPoses } from './get-poses';

export const MerchantPosesAPI = {
  getPoses,
};

export type { Pos } from './types-get-poses';
